import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import type { PartyShellPalette } from "../theme/theme";

/** Instruction block for imposter online phases (readable title + body + optional timer line). */
export function ImposterOnlinePhaseHint({
  partyPal,
  title,
  body,
  timerLine,
}: {
  partyPal: PartyShellPalette;
  title: string;
  body: string;
  timerLine?: string | null;
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.25,
        borderRadius: 3,
        border: `1.5px solid ${partyPal.inkFaint}`,
        bgcolor: "rgba(255,255,255,0.06)",
      }}
    >
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 800,
          color: partyPal.ink,
          mb: 1,
          lineHeight: 1.35,
          fontFamily: "var(--font-display)",
        }}
      >
        {title}
      </Typography>
      <Typography sx={{ fontSize: 16, color: partyPal.inkDim, lineHeight: 1.55 }}>{body}</Typography>
      {timerLine ? (
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: partyPal.hot, mt: 1.75, lineHeight: 1.4 }}>{timerLine}</Typography>
      ) : null}
    </Paper>
  );
}
